import React from 'react';
import { normalizeMapPosition } from '../utils/mapCoordinates';

/**
 * HTML location summary (no Google InfoWindow) — GOVOPS-1106 stability.
 */
const MapLocationSummary = ({ position, title, lines = [] }) => {
  const coords = normalizeMapPosition(position);
  if (!coords) return null;

  return (
    <div className="rhs-card rhs-map-location-summary" role="status">
      {title && <h4 className="rhs-card-title">{title}</h4>}
      <p className="rhs-muted text-sm mb-1">
        {coords.lat.toFixed(6)}, {coords.lng.toFixed(6)}
      </p>
      {lines.filter(Boolean).map((line) => (
        <p key={line} className="text-sm">
          {line}
        </p>
      ))}
    </div>
  );
};

export default MapLocationSummary;
